export default "__VITE_ASSET__eb408f73__"